var r,n;function a(){if(n)return r;n=1;var i=function(){};return r=i,r}export{a as __require};
